'use strict';

var parseHref = require('./parseHref.js');

/**
 * Checks if two URIs match.
 *
 * @param a - The first URI.
 * @param b - The second URI.
 * @returns `true` if the URIs match, `false` otherwise.
 */ function uriMatch(a, b) {
    return a && a.length && parseHref(a).href === parseHref(b).href ? true : false;
}

module.exports = uriMatch;
